import React from "react";
import WrappedChangeEmailForm from "./account/changeEmail"
import WrappedChangePasswordForm from './account/changePassword'

const AccountMaintenance = props => {
  //console.log(props)
  return (
    <div className="content">
      <h2>{props.title}</h2>
      <WrappedChangeEmailForm />
      <br/>
      <WrappedChangePasswordForm />
    </div>
  );
};

export default AccountMaintenance;
